import { call, put, spawn, takeLeading } from 'redux-saga/effects';

import api from '../api';
import {
    CREATE_FOREST_ESTIMATE,
    CREATE_FOREST_ESTIMATE_STARTED,
    CREATE_FOREST_ESTIMATE_SUCCESSFUL,
    CREATE_FOREST_ESTIMATE_FAILED,
} from '../ducks/forest_estimates/forestEstimateCreation';

function* createForestEstimate(action) {
    yield put({ type: CREATE_FOREST_ESTIMATE_STARTED });
    try {
        const response = yield call(
            api.forestEstimates.create.post,
            null,
            action.payload,
        );
        yield put({ type: CREATE_FOREST_ESTIMATE_SUCCESSFUL, response });
        yield call(action.callback, response.id);
    } catch (error) {
        yield put({ type: CREATE_FOREST_ESTIMATE_FAILED, error });
        yield call(action.errorCallback, error);
    }
}

function* createForestEstimateSaga() {
    yield takeLeading(CREATE_FOREST_ESTIMATE, createForestEstimate);
}

export default function* forestEstimateCreationRootSaga() {
    yield spawn(createForestEstimateSaga);
}
